import React from 'react';
import { getTypeIconSymbol } from 'site-modules/shared/utils/upper-funnel/get-svg-icon';

export function TypeIconSymbolSheet() {
  return (
    <div className="pos-a" style={{ width: '0', height: '0', visibility: 'hidden' }} aria-hidden>
      {getTypeIconSymbol}
    </div>
  );
}
